import './less/newsletterStripe.less';

export default (function () {
	let newsletterForm = () => {
		$(document).on("submit", ".JS_newsletter-form", function (e) {
			e.preventDefault();
			
			const form = this;
			let fd = new FormData(form);
			let responseBox = document.getElementById('JS_subscribe-form-response');
			let agrees = $('.JS_agree[data-required="true"]:not(:checked)');
			
			$('.JS_agree').each(function(i, item){
				item.closest('.checkbox-wrapper').classList.remove('error');
			});
			
			// $(responseBox).closest('.newsletter-info').slideUp(function(){
				responseBox.innerHTML = '';
			// });
			
			if (agrees.length === 0) {
				if(!form.classList.contains('busy')) {
					form.classList.add('busy');
					
					let request = $.ajax({
						url: form.action,
						type: 'post',
						data: fd,
						dataType: 'json',
						processData: false,
						contentType: false
					});
					
					request.then(response => {
						form.classList.remove('busy');
						responseBox.innerHTML = response.data.html;
						$(responseBox).closest('.newsletter-info').slideDown();
					});
				}
			} else {
				agrees.each(function(i, item) {
					item.closest('.checkbox-wrapper').classList.add('error');
				});
			}
			
			
		});
	};
	
	newsletterForm();
	
	
	/* Newsletter */
	// $(document).find("form[name='newsletter-form']").on("submit", function(e){
	//     e.preventDefault();
	// });
	//
	// $(document).on("click", ".submit-newsletter", function(e) {
	//     e.preventDefault();
	//     var agrees = $('.JS_agree:checked');
	//
	//     if (agrees.length === 2) {
	//         var self = $(this);
	//         var form = $(document).find("form[name='newsletter-form']");
	//         var ni = $(document).find(".newsletter-info");
	//
	//         if (!self.hasClass("busy")) {
	//             self.addClass("busy");
	//             ni.slideUp(function () {
	//                 $(this).find(".newsletter-info-inner").text("");
	//
	//                 $.post(form.attr("action"), form.serialize(), function (data) {
	//                     if (data.length > 0) {
	//                         var response = data.split("||");
	//                         var status = response[0];
	//                         var msg = response[1];
	//
	//                         ni.find(".newsletter-info-inner").text(msg);
	//                         ni.slideDown(function () {
	//                             setTimeout(function () {
	//                                 ni.slideUp(function () {
	//                                     ni.find(".newsletter-info-inner").text("");
	//                                     self.removeClass("busy");
	//                                 });
	//                             }, 2000);
	//                         });
	//                     } else {
	//                         self.removeClass("busy");
	//                     }
	//                 });
	//             });
	//         }
	//     } else{
	//         var closer = $('.JS_agreeCloser');
	//         var box = $('.newsletter-agrees__overlay');
	//         box.fadeIn();
	//
	//         closer.click(function(){
	//             box.fadeOut();
	//         });
	//     }
	// });
	/* //Newsletter */
	
	
})();


// WEBPACK FOOTER //
// ./components/newsletterStripe/newsletterStripe.js